import React from 'react';
import { User } from '@bforms-web/common';
import { Delete } from '@material-ui/icons';
import { USER_REGISTER_ROUTE, USER_EDIT_ROUTE } from '../../constants';
import Table, { TableProps } from '../Table';

const columns = [
  {
    key: 'email',
    label: 'Email',
  },
  {
    key: 'name',
    label: 'Nome',
  },
];

export type UserTableProps = {
  data: User[];
  onDelete?: (user: User) => void;
} & Pick<
  TableProps,
  'count'
  | 'onChangePage'
  | 'onChangeRows'
  | 'onSearch'
  | 'page'
  | 'rowsPerPage'
>;

const UserTable = React.memo(({ 
  data, 
  onDelete,
  ...props
}: UserTableProps) => {
  return (
    <Table
      columns={columns}
      data={data}
      title={'Usuários'}
      size="small"
      canAdd
      addRoute={USER_REGISTER_ROUTE}
      canEdit
      editRoute={USER_EDIT_ROUTE}
      extraActions={onDelete ? [
        {
          icon: <Delete />,
          label: 'Excluir',
          onExecute: (user: User) => onDelete(user),
        },
      ] : undefined}
      {...props}
    />
  );
});

export default UserTable;
